import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';

import { ControlDataExportFile } from '../../model/control-data/control-data-export-file';
import { DataService } from '../../../core/service/base/data.service';

@Injectable()
export class ControlDataExportFileService extends DataService<ControlDataExportFile> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, ControlDataExportFile, progressBar, 'control-data-export-file');
  }
}
